// extracted by css-extract-rspack-plugin
module.exports =  {"card":"PendingGroupCard-kuvL__card","header":"PendingGroupCard-GtZU__header","title":"PendingGroupCard-ZQNH__title","message":"PendingGroupCard-KMsF__message"};